// src/components/TextBox.js
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import ThemeContext from '../context/ThemeContext';

// Styled container for the textbox
const StyledTextBox = styled.div`
  background-color: ${({ bgColor }) => bgColor ? `rgba(${parseInt(bgColor.slice(1, 3), 16)}, ${parseInt(bgColor.slice(3, 5), 16)}, ${parseInt(bgColor.slice(5, 7), 16)}, 0.4)` : 'rgba(240, 240, 240, 0.4)'};
  color: ${({ textColor }) => textColor || '#000'};
  border: 1px solid ${({ textColor }) => textColor || '#000'};
  padding: 20px;
  border-radius: 8px;
  margin: 10px 0;
  max-width: 800px;
  cursor: pointer;
  transition: transform 0.8s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${({ clicked }) => (clicked ? 'rotateY(180deg)' : 'rotateY(0deg)')};

  &:hover {
    background-color: ${({ bgColor }) => bgColor ? `rgba(${parseInt(bgColor.slice(1, 3), 16)}, ${parseInt(bgColor.slice(3, 5), 16)}, ${parseInt(bgColor.slice(5, 7), 16)}, 0.8)` : 'rgba(240, 240, 240, 0.8)'};
  }
`;

const ContentWrapper = styled.div`
  transform: rotateY(${({ clicked }) => (clicked ? '180deg' : '0deg')});
  transition: transform 0.8s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TextBox = ({ children }) => {
  const { theme } = useContext(ThemeContext);
  const [clicked, setClicked] = useState(false);

  // Separate the h2 and p elements
  const header = children.find(child => child.type === 'h2');
  const paragraph = children.find(child => child.type === 'p');

  return (
    <StyledTextBox
      bgColor={theme.mainField}
      textColor={theme.mainText}
      clicked={clicked}
      onClick={() => setClicked(!clicked)}
    >
      <ContentWrapper clicked={clicked}>
        {clicked ? paragraph : header}
      </ContentWrapper>
    </StyledTextBox>
  );
};

export default TextBox;
